import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";

export class AccountAgentsConfigViewComponent implements IController {
  account: AccountModel;

  public currentNavItem: any;

  constructor(private $state) {
  }

  $onInit() {
    this.currentNavItem = this.$state.current.url;
  }

  changeState(stateName) {
    this.$state.go('^.' + stateName, {}, {notify: true, reload: false});
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountAgentsConfigView', {
    bindings: {
      account: '<'
    },
    template: require('./account-agents-config-view.html').default,
    controller: AccountAgentsConfigViewComponent
  });
